import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { HasFormComponent } from '../../../core/interfaces/hasFormComponent';
import { FormGroup } from '@angular/forms';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';

@Component({
  selector: 'ndms-label',
  templateUrl: './ndms-label.component.html',
  styleUrls: ['./ndms-label.component.scss']
})
export class NdmsLabelComponent extends NdmsFormControlComponent implements OnInit {
  @Input() span: boolean;
  @Input() for: string;

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef)

    let parentComponent = (<any>viewContainerRef.injector).view.component;

    if (parentComponent instanceof NdmsFormControlComponent) {
      this.label = parentComponent.label;
      this.group = parentComponent.group;
      this.field = parentComponent.field;
      this.required = parentComponent.required;
    }
  }

  ngOnInit() {
  }
}
